/**
 * Clé du composant de la route affichée. Vue Router réutilise l'instance quand deux routes pointent
 * vers le même composant (/ListeAnimaux et /ListeAnimauxSanitaire) : filtres, recherche rapide et
 * cases cochées passeraient alors d'un écran à l'autre. Une route marquée `meta.isolateInstance`
 * reçoit sa propre clé, donc sa propre instance ; les autres gardent le comportement par défaut.
 */
export const routeViewKey = (route: { name?: string | symbol | null; meta?: Record<string | symbol, unknown> }): string | undefined =>
    route.meta?.isolateInstance && route.name != null ? String(route.name) : undefined;
